import {
  FETCH_WORKFLOW_DEFINITIONS,
  CREATE_WORKFLOW_DEFINITION,
  UPDATE_WORKFLOW_DEFINITION,
  DELETE_WORKFLOW_DEFINITION,
  TOGGLE_WORKFLOW_DEFINITION,
  LAUNCH_WORKFLOW_INSTANCE,
  FETCH_WORKFLOW_ENTITY_INSTANCES,
  FETCH_WORKFLOW_INBOX,
  WORKFLOW_APPROVE_STEP,
  WORKFLOW_REJECT_STEP,
  WORKFLOW_ADD_COMMENT,
  RECALL_WORKFLOW_INSTANCE,
  CANCEL_WORKFLOW_INSTANCE,
  WORKFLOW_LOADING,
  WORKFLOW_ERROR,
} from "../actions/workflowActions";

const initialState = {
  definitions: [],
  instances: {},
  entityInstances: {},
  inbox: [],
  inboxTotal: 0,
  loading: false,
  error: null,
};

const updateInstance = (state, updatedInstance) => {
  const id = updatedInstance._id;
  const updated = { ...state.instances, [id]: updatedInstance };
  const updatedEntityInstances = { ...state.entityInstances };
  const key = `${updatedInstance.entityType}:${updatedInstance.entityId}`;
  if (updatedEntityInstances[key]) {
    updatedEntityInstances[key] = updatedEntityInstances[key].map((i) =>
      i._id === id ? updatedInstance : i
    );
  }
  return { ...state, instances: updated, entityInstances: updatedEntityInstances };
};

const workflowReducer = (state = initialState, action) => {
  switch (action.type) {
    case WORKFLOW_LOADING:
      return { ...state, loading: true, error: null };

    case WORKFLOW_ERROR:
      return { ...state, loading: false, error: action.payload };

    case FETCH_WORKFLOW_DEFINITIONS:
      return { ...state, loading: false, definitions: action.payload };

    case CREATE_WORKFLOW_DEFINITION:
      return {
        ...state,
        definitions: [action.payload, ...state.definitions],
      };

    case UPDATE_WORKFLOW_DEFINITION:
    case TOGGLE_WORKFLOW_DEFINITION:
      return {
        ...state,
        definitions: state.definitions.map((d) =>
          d._id === action.payload._id ? action.payload : d
        ),
      };

    case DELETE_WORKFLOW_DEFINITION:
      return {
        ...state,
        definitions: state.definitions.filter((d) => d._id !== action.payload),
      };

    case LAUNCH_WORKFLOW_INSTANCE:
      return {
        ...state,
        instances: { ...state.instances, [action.payload._id]: action.payload },
      };

    case FETCH_WORKFLOW_ENTITY_INSTANCES:
      return {
        ...state,
        entityInstances: {
          ...state.entityInstances,
          [action.payload.key]: action.payload.instances,
        },
      };

    case FETCH_WORKFLOW_INBOX:
      return {
        ...state,
        loading: false,
        inbox: action.payload.items,
        inboxTotal: action.payload.total,
      };

    case WORKFLOW_APPROVE_STEP:
    case WORKFLOW_REJECT_STEP:
    case WORKFLOW_ADD_COMMENT:
    case RECALL_WORKFLOW_INSTANCE:
    case CANCEL_WORKFLOW_INSTANCE:
      return updateInstance(state, action.payload);

    default:
      return state;
  }
};

export default workflowReducer;
